export const getLoremIpsum = (repeat = 0, short?: boolean) => {
    const shortText = 'Qui sadipscing eirmod sanctus et magna. ';
    const longText = `Qui sadipscing eirmod sanctus et magna. 
                Sadipscing ipsum sed ipsum dolor kasd ea cum lobortis iusto sadipscing kasd ut feugiat. 
                Molestie lorem feugiat sanctus sea sit ipsum sit dolor elitr diam gubergren dolores accusam consetetur accusam at. 
                Zzril dolor magna voluptua vero sed dolore consequat duo dolores sed dignissim est aliquyam at sea.`;

    const text = short ? shortText : longText;

    return text.repeat(repeat);
};
